import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
export function extractContributed(paraId, events) {
  var _events$createdAtHash;

  var added = [];
  var removed = [];
  return events.filter(function (_ref) {
    var _ref$event = _ref.event,
        _ref$event$data = _slicedToArray(_ref$event.data, 2),
        eventParaId = _ref$event$data[1],
        method = _ref$event.method,
        section = _ref$event.section;

    return section === 'crowdloan' && ['Contributed', 'Withdrew'].includes(method) && eventParaId.eq(paraId);
  }).reduce(function (result, _ref2) {
    var _ref2$event = _ref2.event,
        _ref2$event$data = _slicedToArray(_ref2$event.data, 1),
        accountId = _ref2$event$data[0],
        method = _ref2$event.method;

    if (method === 'Contributed') {
      result.added.push(accountId.toHex());
    } else {
      result.removed.push(accountId.toHex());
    }

    return result;
  }, {
    added: added,
    blockHash: ((_events$createdAtHash = events.createdAtHash) === null || _events$createdAtHash === void 0 ? void 0 : _events$createdAtHash.toHex()) || '-',
    removed: removed
  });
}